import { formatDate } from "../utils/authUtils";
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * */

export const users = [
  {
    _id: 2,
    firstName: "Adam",
    lastName: "Grillo",
    username: "a_grillz10",
    password: "Password123#",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    email: "email@gmail.com",
    img: "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    bio: "Be true to yourself.",
    portfolio: "https://www.adamGrillo.com",
  },
  {
    _id: 3,
    firstName: "Chelsea",
    lastName: "Phillips",
    username: "chelphill",
    password: "Password123#",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    email: "email@gmail.com",
    img: "https://images.unsplash.com/photo-1552699611-e2c208d5d9cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8cG9ydHJhaXQlMjB3b21hbnxlbnwwfHwwfHx8MA%3D%3D&w=1000&q=80",
    bio: "Making lemonade out of lemons.",
    portfolio: "https://www.chelseaPhillips.com",
  },
  {
    _id: 4,
    firstName: "Kenyi",
    lastName: "Matos",
    username: "kenyimatos",
    password: "Password123#",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    email: "email@gmail.com",
    img: "https://i.pinimg.com/originals/ec/f3/db/ecf3db173fea15839fdfe0625b25bfec.jpg",
    bio: "The best is yet to come.",
    portfolio: "https://www.kenyimatos.com",
  },
  {
    _id: 5,
    firstName: "Jared ",
    lastName: "Schablein",
    username: "throw_to_ten",
    password: "Password123#",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    email: "email@gmail.com",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSLgor3-ytFOoqo9hpW51RUSQcl86FtBWB52g&usqp=CAU",
    bio: "One smile can turn around a bad day",
    portfolio: "https://www.Schablein.com",
  },
  {
    _id: 6,
    firstName: "Milli",
    lastName: "Mill",
    username: "millimill",
    password: "Password123#",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    email: "email@gmail.com",
    img: "https://i.pinimg.com/236x/8e/7c/2b/8e7c2ba6030548ecc66f5ae9e3da9053.jpg",
    bio: "Be the good you want to see in the world.",
    portfolio: "https://www.millimill.com",
  },
  {
    _id: 7,
    firstName: "Jim ",
    lastName: "Walker",
    username: "scotland7jimw",
    password: "Password123#",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    email: "email@gmail.com",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSixJD0jcM9K6cxaaCViE5QT0Ku3UN6E97KQA&usqp=CAU",
    bio: "Life can be tough—coffee helps",
    portfolio: "https://www.jimWalker.com",
  },
  {
    _id: 8,
    firstName: "Gloria",
    lastName: "Hatcher",
    username: "gloriaHatcher",
    password: "Password123#",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    email: "email@gmail.com",
    img: "https://i.pinimg.com/236x/a8/9c/9b/a89c9bb8651fb5534daec837b38383fd--naturally-beautiful-its-beautiful.jpg",
    bio: " I get it from my mama.",
    portfolio: "https://www.gloriaHatcher.com",
  },
  {
    _id: 9,
    firstName: "Dimitri ",
    lastName: "vanderpool ",
    username: "dimitrihere",
    password: "Password123#",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    email: "email@gmail.com",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSdRdhpwzq316ezf7aCX9wNRHld6sJ3nWIP0A&usqp=CAU",
    bio: "It’s a good day to have a good day",
    portfolio: "https://www.dimitrihere.com",
  },
  {
    _id: 10,
    firstName: "Mike ",
    lastName: "Purcell",
    username: "mpurcell50",
    password: "Password123#",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    email: "email@gmail.com",
    img: "https://media.istockphoto.com/id/180841365/photo/hes-a-handsome-man.jpg?s=612x612&w=0&k=20&c=vjQLLI8g_a0O6_xx0plUu3CJ9AMhnSzHssLwgem8gE4=",
    bio: "Welcome to my world.",
    portfolio: "https://www.mpurcell.com",
  },
  {
    _id: 11,
    firstName: "maxime ",
    lastName: "prudhomme ",
    username: "maximep123",
    password: "Password123#",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    email: "email@gmail.com",
    img: "https://i.pinimg.com/originals/2c/a3/01/2ca301559a8f579fe5e17969f602bcda.jpg",
    bio: "The best things come from living outside of your comfort zone",
    portfolio: "https://www.maximep.com",
  },
];
